import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Options} from 'select2';
import {Select2OptionData} from 'ng-select2';
import {ProductsListModel} from '../../../shared/models/productsList.model';
import {PersonalNotesModel} from '../../../shared/models/personalNotes.model';
import {OffersDataService} from '../_services/offers-data.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-edit-offer',
    templateUrl: './edit-offer.component.html',
    styleUrls: ['./edit-offer.component.scss']
})

export class EditOfferComponent implements OnInit {

    constructor(private offersDataService: OffersDataService, private route: ActivatedRoute, private router: Router, private snackBar: MatSnackBar) {
    }

    // Select 2 Options
    public singleOption: Options;

    formResponse: boolean;
    formSent: boolean;
    isLoaded: boolean;

    // Form Object
    offerId: any;
    offerData: any = [];

    allCompanyData: any = [];
    clientUserId: Array<Select2OptionData> = [];
    clientDataLoaded: boolean;

    setCurrentDate: string;

    // Repeater
    offerDTO: any = [];
    nextId = 0;
    repeaterData: {
        productList: ProductsListModel[];
        personalNotes: PersonalNotesModel[];
    }

    timeDuration = 5000;


    ngOnInit() {
        this.setCurrentDate = new Date().toISOString().split('T')[0];

        this.singleOption = {
            width: '100%',
            placeholder: ' -- Selecteaza optiune -- ',
            allowClear: true
        };

        this.repeaterData = {
            productList: [],
            personalNotes: []
        }

        this.addProduct();
        this.addPersonalNotes();

        this.offersDataService.getAllCompany().subscribe(res => {
            this.allCompanyData = res;
            this.allCompanyData.forEach(data => {
                this.clientUserId.push({id: data.id, text: data.companyName});
            })
            this.clientDataLoaded = true;
        })

        this.route.params.subscribe((params: Params) => {
            this.offerId = params.id;
            this.offersDataService.viewSingleOffer(this.offerId).subscribe(offerData => {
                this.offerData = offerData
                if (this.offerData.productList != null) {
                    this.repeaterData.productList = this.offerData.productList;
                }
                this.isLoaded = true;

            })

        })

    }


    editOffer(offerData: NgForm) {

        this.route.params.subscribe((params: Params) => {
            this.offerId = params.id;
            this.offersDataService.viewSingleOffer(this.offerId).subscribe((res: any) => {
                this.offerData = res
            })
        })

        // Repeater Object
        this.offerDTO = {
            productList: offerData.value.productList,
            personalNotes: offerData.value.personalNotes
        }

        // Product Repeater
        const productValue = [];
        for (const key of Object.keys(this.offerDTO.productList)) {
            const product = this.offerDTO.productList[key];
            productValue.push(product);
        }

        // Personal Notes Repeater
        const personalNotesValue = this.offerData.personalNotes;
        for (const key of Object.keys(this.offerDTO.personalNotes)) {
            const notes = this.offerDTO.personalNotes[key];
            personalNotesValue.push(notes);
        }

        this.offerData = {
            name: offerData.value.name,
            clientUserId: offerData.value.clientUserId,
            offerDate: offerData.value.offerDate,
            deadline: offerData.value.deadline,
            observation: offerData.value.observation,
            status: offerData.value.status,
            productList: productValue.length === 0 ? null : productValue,
            personalNotes: personalNotesValue.length === 0 ? [{note: undefined, author: undefined, date: undefined}] : personalNotesValue
        }

        this.offersDataService.editOffer(this.offerId, this.offerData).subscribe((res: any) => {
            this.formResponse = true;
            this.formSent = true;
            setTimeout(() => {
                this.router.navigate(['/sistemerp/oferte/oferta/' + res['reason']])
            }, 4000);

            // this.openNotification('Oferta a fost modificata cu succes!');
        }, error => {
            this.formResponse = false;
            this.formSent = true;
            // this.openNotification('A aparut o eroare!');
        })
    }


    // Repeater
    trackByFunction(index, item) {
        return item.index;
    }

    getId() {
        this.nextId = this.nextId + 1;
        return this.nextId;
    }

    // Product Repeater -- Start
    addProduct() {
        this.repeaterData.productList.push({
            name: '',
            price: 0
        });
    }

    removeProduct(index: number) {
        this.repeaterData.productList.splice(index, 1);
    }

    // Product Repeater -- END

    // Personal Notes Repeater -- Start
    addPersonalNotes() {
        this.repeaterData.personalNotes.push({
            author: '',
            note: '',
            date: undefined
        });
    }

    removePersonalNotes(index: number) {
        this.repeaterData.personalNotes.splice(index, 1);
    }

    // Personal Notes Repeater -- END


    openNotification(message) {
        this.snackBar.open(message, 'Inchide', {
            duration: this.timeDuration,
            horizontalPosition: 'center',
            verticalPosition: 'top'
        });
    }
}
